// Component detail panel pagination sizes
export const COMP_DETAIL_PAGE_SIZE = 25; // default rows shown per Prev/Next page
export const COMP_DETAIL_FETCH_SIZE = 100; // rows fetched from the server per call
export const COMP_DETAIL_PAGE_SIZE_OPTIONS = [10, 25, 50, 100].map((n) => ({
  value: String(n),
  label: String(n),
}));
